export class BackToTop {
  constructor() {
    this.backToTopBtn = document.getElementById('backToTop');
    this.scrollPos = 0;

    if(this.backToTopBtn){
      this.init();
    }
  }

  init = () => {
    this.backToTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
    document.addEventListener("scroll", () => {
      // detects new state and compares it with the new one
      if (document.body.getBoundingClientRect().top >  this.scrollPos && window.scrollY > 300)
        this.backToTopBtn.style.display = "block";
      else
        this.backToTopBtn.style.display = "none";
      // saves the new position for iteration.
      this.scrollPos = (document.body.getBoundingClientRect()).top;
    });
  }
}
